<script lang="ts">
import type { PrimitiveProps } from '@/Primitive'

export interface RangeCalendarHeadCellProps extends PrimitiveProps {}
</script>

<script setup lang="ts">
import { Primitive } from '@/Primitive'

const props = withDefaults(defineProps<RangeCalendarHeadCellProps>(), { as: 'th' })
</script>

<template>
  <Primitive v-bind="props">
    <slot />
  </Primitive>
</template>
